module.exports = __webpack_public_path__ + "static/yc-ec65b8bb54e474845e612f37786b61e4.png";